<template>
    <div class="row">
        <div class="col-xl-8">
            <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-8">
                            <h3 class="mb-0">Elevator Components</h3>
                        </div>
                    </div>
                </div>
                <template>
                    List here...
                </template>
            </card>
        </div>
        <div class="col-xl-4">
            <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-8">
                            <h3 class="mb-0">Shopping Cart</h3>
                        </div>
                    </div>
                </div>
                <template>
                    List here...
                </template>
            </card>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'user-profile',
    data() {
      return {
        model: {
          username: '',
          email: '',
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          country: '',
          zipCode: '',
          about: '',
        }
      }
    },
  };
</script>
<style></style>
